<div class="custom-dialog-header">
  <div class="custom-dialog-close-container">
    <button type="button" class="custom-dialog-close-btn" (click)="close()">
      <span class="pi pi-times"></span>
    </button>
  </div>
</div>
<div class="panel_wrapper">
  <div class="upload-images-wrapper">
    <div class="upload-your-images-div">{{'VENUE.UPLOAD_IMAGES_MESSAGE_1' | translate}}</div>
    <div class="choose-images-div pb-4 m-0">{{'VENUE.UPLOAD_IMAGES_MESSAGE_2' | translate}}</div>
    <div class="upload-div d-flex flex-column" appDragNDrop (click)="openAddImage()" (fileDropped)="onDropFile($event)">
      <div>
        <img src="assets/icons/upload_24px.svg" style="height: 80px;">
        <div class="choose-images-div">{{'VENUE.UPLOAD_IMAGES_MESSAGE_3' | translate}}
          <label *ngIf="pictureIsWrongFormat && !tooManyFiles">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{'VENUE.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
          <label *ngIf="tooManyFiles">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{'VENUE.TOO_MANY_FILES' | translate}}" tooltipPosition="top"></i>
          </label>
        </div>
        <div class="choose-images-div mt-2">{{images.length}}/10</div>
      </div>
    </div>
    <input style="display: none;" type="text" #eventImagePath/>
    <input (change)="onSelectFile($event)" class="open-file" style="display: none;" type="file" id="openFile" #openFile
           name="openFile" accept="image/png, image/jpg, image/jpeg" multiple>
  </div>
  <div *ngIf="images.length > 0" class="d-flex justify-content-end mt-3">
    <button *ngIf="!deleteImages" class="btn_cancel_no_border p-0 m-0"
            (click)="enableDeleteImages()">{{ 'DELETE' | translate }}</button>
    <button *ngIf="deleteImages" class="btn_cancel_no_border p-0 m-0 magenta-color"
            (click)="deleteSelectedImages()">{{ 'VENUE.DELETE_IMAGES' | translate }}</button>
  </div>
  <div *ngIf="images.length > 0" class="d-flex flex-column mt-3">
    <div class="d-flex flex-column" style="max-height: 200px; overflow: auto; padding-right: 10px;">
      <ng-container *ngFor="let image of images">
        <div class="mt-1" style="position: relative;" *ngIf="image.progress < 100">
          <span class="progress-bar-custom-label" title="{{image.imageName}}">{{image.imageName}}</span>
          <p-progressBar [showValue]="false" [value]="image.progress" class="mt-1"></p-progressBar>
        </div>
      </ng-container>
    </div>
    <div class="d-flex flex-column" style="max-height: 300px; overflow: auto;">
      <div *ngFor="let image of images">
        <div class="image-container">
          <span><p-checkbox *ngIf="deleteImages" name="deleteImages" [value]="image" [(ngModel)]="imagesToDelete"></p-checkbox></span>
          <img [src]="image.imagePath" *ngIf="image.progress === 100" class="loaded-image">
        </div>
      </div>
    </div>
  </div>
</div>
